(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fastutv-collection-browser"] && !Shopify.designMode) return;
  try {
    const enableFastUTVBrowseSelects = () => {
    for (const browser of document.querySelectorAll('[data-collection-browser]')) browser.setAttribute('data-selects-ready', '');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enableFastUTVBrowseSelects, { once: true });
  else enableFastUTVBrowseSelects();
  document.addEventListener('shopify:section:load', enableFastUTVBrowseSelects);
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-browse-select]');
    if (!select || !select.value) return;
    const destination = new URL(select.value, location.origin);
    if (select.dataset.browseParam) {
      const value = select.selectedOptions[0].dataset.browseValue;
      destination.searchParams.delete(select.dataset.browseParam);
      if (value !== undefined) destination.searchParams.set(select.dataset.browseParam, value);
    }
    if (destination.origin === location.origin) location.assign(destination.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fastutv-lazy-reels"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const videos = [...document.querySelectorAll('video[data-fastutv-reel]:not([data-observed])')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection?.saveData;
    const activate = (video) => {
      if (!video.dataset.loaded) {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        video.dataset.loaded = 'true';
        video.load();
      }
      video.muted = true;
      video.play().catch(() => {});
    };
    if (!('IntersectionObserver' in window) || reducedMotion.matches || saveData) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        video.dataset.inView = String(isIntersecting);
        if (isIntersecting && !document.hidden) activate(video);
        else video.pause();
      });
    }, { rootMargin: '100px 0px', threshold: 0.15 });
    videos.forEach((video) => {
      video.dataset.observed = 'true';
      observer.observe(video);
    });
    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => {
        if (document.hidden) video.pause();
        else if (video.dataset.inView === 'true') activate(video);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
